import Bottom from '@assets/blue-new-deal/bnd-newsletter-bottom.svg?react';
import Tablet from '@assets/blue-new-deal/bnd-newsletter-tablet.svg?react';
import Top from '@assets/blue-new-deal/bnd-newsletter-top.svg?react';
import { ContentType, Content } from './NewsletterSignUp';

export const getNewsletterSignUpContent = ({
  type,
  imageSrc,
}: {
  type: ContentType;
  imageSrc: string;
}): Content => {
  const baseContent = {
    kicker: 'Newsletter',
    image: imageSrc,
    showImage: true,
    wrapperClasses: 'bc-newsletter',
  };

  const newsletterContent = {
    ...baseContent,
    title: (
      <>
        Haltung braucht Argumente. <span>Wir liefern sie.</span>
      </>
    ),
    text: (
      <>
        Die klügsten Stimmen zu den wichtigsten Themen. Einmal wöchentlich
        direkt in Ihr Postfach mit dem Newsletter des Freitag.{' '}
        <a href="/newsletter">Mehr erfahren</a>
      </>
    ),
  };

  const blueNewDealContent = {
    ...baseContent,
    title: (
      <>
        <span>Ozeane:</span> Die blauen Beschützer
      </>
    ),
    svg: (
      <>
        <Top
          role="img"
          viewBox="0 0 800 600"
          className="bc-newsletter__bnd-bg u-hidden-@m"
          preserveAspectRatio="none"
        />
        <Bottom
          className="bc-newsletter__bnd-bg u-hidden-@m"
          style={{ bottom: '-20%' }}
          role="img"
          viewBox="0 0 800 600"
          preserveAspectRatio="none"
        />
      </>
    ),
    svgMediumScreen: (
      <Tablet
        className="bc-newsletter__bnd-bg--md u-display--none u-show-@m"
        role="img"
        preserveAspectRatio="none"
      />
    ),
  };

  const content: Record<ContentType, Content> = {
    default: {
      ...newsletterContent,
      wrapperClasses: `${newsletterContent.wrapperClasses}`,
    },
    breaker: {
      ...newsletterContent,
      wrapperClasses: `${newsletterContent.wrapperClasses} bc-newsletter--breaker`,
    },
    breakerFooter: {
      ...newsletterContent,
      wrapperClasses: `${newsletterContent.wrapperClasses} bc-newsletter--breaker-footer`,
    },
    breakerRelated: {
      ...newsletterContent,
      text: (
        <>
          Die Freitag-Themen der Woche &ndash; direkt per Mail.{' '}
          <a href="/newsletter">Mehr erfahren</a>
        </>
      ),
      wrapperClasses: `${newsletterContent.wrapperClasses} bc-newsletter--breaker-related`,
    },
    landingpage: {
      ...newsletterContent,
      title: (
        <>
          <span>Die besten Argumente –</span> direkt in Ihr Postfach
        </>
      ),
      text: (
        <>
          Mit unserem kostenlosen Newsletter erhalten Sie jeden Mittwoch einen
          Überblick über die neue Ausgabe des Freitag. Das bedeutet: das
          Wichtigste der Woche aus progressiver Perspektive, Denkanstöße,
          Hintergründe und die besten Argumente für die aktuellen Debatten
          &ndash; direkt per Mail.
        </>
      ),
      showImage: false,
      wrapperClasses: `${newsletterContent.wrapperClasses} bc-newsletter--landingpage`,
    },
    landingpageCompact: {
      ...newsletterContent,
      text: undefined,
      kicker: undefined,
      wrapperClasses: `${newsletterContent.wrapperClasses} bc-newsletter--landingpageCompact`,
    },
    landingpageBlueNewDeal: {
      ...blueNewDealContent,
      text: (
        <>
          Lassen Sie sich informieren, sobald wir neue Texte aus der „Blue New
          Deal“-Serie und weitere Recherchen und Analysen zur Zukunft des
          Planeten ver&ouml;ffentlichen. Mit dem Newsletter zur Serie bekommen
          Sie außerdem exklusive Einblicke in die Arbeit unserer ReporterInnen.
        </>
      ),
      showImage: false,
      wrapperClasses: `${blueNewDealContent.wrapperClasses} bc-newsletter--landingpage bc-newsletter--blue-new-deal`,
    },
    blueNewDeal: {
      ...blueNewDealContent,
      text: (
        <>
          Lassen Sie sich informieren, sobald wir neue Texte aus der „Blue New
          Deal“-Serie und weitere Recherchen und Analysen zur Zukunft des
          Planeten ver&ouml;ffentlichen.
        </>
      ),
      svg: (
        <>
          {blueNewDealContent.svg}
          {blueNewDealContent.svgMediumScreen}
        </>
      ),
      wrapperClasses: `${blueNewDealContent.wrapperClasses} bc-newsletter--breaker bc-newsletter--blue-new-deal`,
    },
    blueNewDealRelated: {
      ...blueNewDealContent,
      text: <>Alle Texte der „Blue New Deal“-Serie – direkt ins Postfach.</>,
      svg: (
        <>
          {blueNewDealContent.svg}
          {blueNewDealContent.svgMediumScreen}
        </>
      ),
      wrapperClasses: `${blueNewDealContent.wrapperClasses} bc-newsletter--breaker-related bc-newsletter--blue-new-deal`,
    },
    newsletterpage: {
      ...newsletterContent,
      title: (
        <>
          <span>Die besten Argumente –</span> direkt in Ihr Postfach
        </>
      ),
      text: (
        <>
          Mit unserem kostenlosen Newsletter erhalten Sie jeden Mittwoch einen
          Überblick über die neue Ausgabe des Freitag. Das bedeutet: das
          Wichtigste der Woche aus progressiver Perspektive, Denkanstöße,
          Hintergründe und die besten Argumente für die aktuellen Debatten
          &ndash; direkt per Mail.
        </>
      ),
      showImage: false,
      wrapperClasses: `${newsletterContent.wrapperClasses} bc-newsletter--newsletterpage`,
    },
  };

  return content[type];
};

export const getNewsLetterServiceProps = (type: ContentType) => {
  const propsType = type.toLowerCase().includes('bluenewdeal')
    ? 'blueNewDeal'
    : 'default';
  const query = '?isAjax=1';

  const content = {
    default: {
      url: `https://9d1950cd.sibforms.com/serve/MUIFAJl8qliyzEiOKBJpypzvoWJja-IGssRYtmw9gLvn1IWtcpOvzumkg_C4l1JKxn_39z3-cwF3zpkb1CIylFkegRsL8z3xyKnq3Kwq__rDmxEVSfq0EYdUzVxgDNZM0rAGNWOq-LsvDDlp2y0Go3JKqhscAepXKxsvcasziuwgVtu7fru5m4BhcmwH9rdPJmBnaCcPVUC8SmDI${query}`,
      tag: 'ArtikelNL',
    },
    blueNewDeal: {
      url: `https://9d1950cd.sibforms.com/serve/MUIFAGUfUsZ9hadc00ld7itfsUm0QalN0yH9_MyZiq3a9rRoHNuJ8WU0rHGZjLV5jGeyvC-3C2qmUGGkGf1RNLyEPWpAOoRrQ5bXPol4EKTAUMthUfadl8nvr3tOSonYvta7QLpl6g61jNQbr8RF7zwfiFg_0R1jvR2R3Kr6p7YgPc85J9OqI8btVHVNJDzBn2BQHmvyWP2otwjt${query}`,
      tag: 'ArtikelBND',
    },
  };

  return content[propsType];
};
